import React from 'react';
import Jumbotron from 'react-bootstrap/Jumbotron';
import Container from 'react-bootstrap/Container';
import { NOME_SISTEMA_COMPLETO, DESCRICAO_SISTEMA } from '../../../utils/constants';
import {Image} from 'react-bootstrap'
import CrowDe from '../../../logo_branco.png'


const Header = () => {
    return (
        <header>
            <Jumbotron fluid className="text-white text-center bg-blue">
                <Container>
                    <Image src={CrowDe} height='65' width='120'></Image>
                    <h3 className="display-4"><strong> {NOME_SISTEMA_COMPLETO}</strong></h3>
                    <p className="lead">{DESCRICAO_SISTEMA}</p>
                </Container>
            </Jumbotron>
        </header>
    );
};


export default Header;
